import { NavigationMenuLink } from "@radix-ui/react-navigation-menu";

import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";

import { useIsDesktop } from "../../hooks/useIsDesktop";
import type { SettingsTab } from "./SettingsManagerUI";

export interface SettingsMenuProps {
  activeMode: SettingsTab;
  setActiveMode: (mode: SettingsTab) => void;
}

export function SettingsMenu({
  activeMode,
  setActiveMode,
}: Readonly<SettingsMenuProps>) {
  const isDesktop = useIsDesktop();
  return (
    <NavigationMenu
      value={activeMode}
      onValueChange={(value) => {
        setActiveMode(value as SettingsTab);
      }}
    >
      <NavigationMenuList>
        <NavigationMenuItem value="aihelp">
          <NavigationMenuLink
            className={`cursor-pointer ${navigationMenuTriggerStyle()} ${activeMode === "knowledge" ? "border border-gray-300 font-bold" : ""}`}
            onClick={() => {
              setActiveMode("knowledge");
            }}
            data-test="settings-knowledge-tab"
          >
            Knowledge
          </NavigationMenuLink>
        </NavigationMenuItem>
        <NavigationMenuItem value="script">
          <NavigationMenuLink
            className={`cursor-pointer ${navigationMenuTriggerStyle()} ${activeMode === "script" ? "border border-gray-300 font-bold" : ""}`}
            onClick={() => {
              setActiveMode("script");
            }}
            data-test="settings-scripts-tab"
          >
            Scripts
          </NavigationMenuLink>
        </NavigationMenuItem>
        {!isDesktop && (
          <NavigationMenuItem value="download">
            <NavigationMenuLink
              className={`cursor-pointer ${navigationMenuTriggerStyle()} ${activeMode === "download" ? "border border-gray-300 font-bold" : ""}`}
              onClick={() => {
                setActiveMode("download");
              }}
              data-test="settings-download-tab"
            >
              Download
            </NavigationMenuLink>
          </NavigationMenuItem>
        )}

        <NavigationMenuItem value="app">
          <NavigationMenuLink
            className={`cursor-pointer ${navigationMenuTriggerStyle()} ${activeMode === "app" ? "border border-gray-300 font-bold" : ""}`}
            onClick={() => {
              setActiveMode("app");
            }}
            data-test="settings-app-tab"
          >
            App
          </NavigationMenuLink>
        </NavigationMenuItem>

        <NavigationMenuItem value="integrations">
          <NavigationMenuLink
            className={`cursor-pointer ${navigationMenuTriggerStyle()} ${activeMode === "integrations" ? "border border-gray-300 font-bold" : ""}`}
            onClick={() => {
              setActiveMode("integrations");
            }}
          >
            Integrations
          </NavigationMenuLink>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
}
